import { render } from "./ConsultaFormularios.vue?vue&type=template&id=89c1f28c"
import script from "./ConsultaFormularios.vue?vue&type=script&lang=js"
export * from "./ConsultaFormularios.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__